import { render, staticRenderFns } from "./EndorsementWording.vue?vue&type=template&id=02444bad&scoped=true"
import script from "./EndorsementWording.vue?vue&type=script&lang=js"
export * from "./EndorsementWording.vue?vue&type=script&lang=js"
import style0 from "./EndorsementWording.vue?vue&type=style&index=0&id=02444bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02444bad",
  null
  
)

export default component.exports